import * as classNames from 'classnames'
import * as React from 'react'
import InputWrapper from './InputWrapper'

interface ITextFieldProps {
  name: string
  value: string
  onChange?: (e: any) => void
  onBlur?: (e: any) => void
  type?: string
  className?: string
  title?: string
  optional?: boolean
  error?: string
  placeholder?: string
  touched?: boolean
  disabled?: boolean
  classNameContainer?: string
  min?: number
  max?: number
  isRed?: boolean
}

const TextField = (props: ITextFieldProps) => {
  const { classNameContainer, type, title, className, optional, touched, error, disabled, isRed, ...rest } = props

  return (
    <InputWrapper
      title={title}
      optional={optional}
      touched={touched}
      error={error}
      className={classNames('mt2', classNameContainer)}
    >
      <input
        type={type || 'text'}
        className={classNames(
          'w100 rounded border-box p1 line-h-18 on-focus-green fs-16',
          {
            'border-light-grey4': !(touched && error) && isRed !== true,
            'border-red :focus-red': !!(touched && error) || isRed === true,
            'bg-light-grey5': disabled
          },
          className
        )}
        disabled={disabled}
        {...rest}
      />
    </InputWrapper>
  )
}

export default TextField



// WEBPACK FOOTER //
// ./src/components/ui/TextField.tsx